var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg",
      class: _vm.className
    },
    [
      _c("div", { staticClass: "flex-auto p-4" }, [
        _c("div", { staticClass: "flex flex-wrap" }, [
          _c(
            "div",
            {
              staticClass:
                "relative w-full pr-4 max-w-full flex-grow flex-1 text-left"
            },
            [
              _c(
                "h5",
                { staticClass: "text-gray-500 uppercase font-bold text-xs" },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.statSubtitle) + "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "font-semibold text-xl text-blueGray-700" },
                [_vm._v("\n          " + _vm._s(_vm.statTitle) + "\n        ")]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "relative w-auto pl-4 flex-initial" }, [
            _c(
              "div",
              {
                staticClass:
                  "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full",
                class: [_vm.statIconColor]
              },
              [_c("i", { class: [_vm.statIconName] })]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-820c4c4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-820c4c4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/CardStats.vue
// module id = null
// module chunks = 